/**
 * Sync triggers
 *
 * FR-010 names five events and FR-011 forbids a polling timer, so this is the
 * whole list. Each just calls `sync()`, which coalesces overlapping runs — so
 * two triggers firing together is harmless by construction.
 *
 * These are the web equivalents of the native lifecycle events a later native
 * build would use; swapping them is the only change this layer needs (FR-032).
 */

/**
 * Install the app-start, foreground and connectivity triggers.
 * @param {Function} sync - the sync engine's coalescing entry point
 * @returns {Function} an uninstall function
 */
export const installSyncTriggers = (sync, onReconnect) => {
  const onOnline = () => {
    sync();
    if (onReconnect) onReconnect();
  };
  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') sync();
  };

  window.addEventListener('online', onOnline);
  document.addEventListener('visibilitychange', onVisibilityChange);

  sync(); // app start

  return () => {
    window.removeEventListener('online', onOnline);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};

/**
 * Trigger after a local write. Offline writes stay queued for the `online`
 * trigger rather than attempting a doomed request.
 */
export const syncAfterLocalWrite = (sync) => {
  if (navigator.onLine !== false) sync();
};
